/**
 * Navigate to a URL without full page refresh using client-side routing
 * Uses History API to update the URL, which React Router will detect
 */
export function browserNavigate(url: string) {
  try {
    const urlObj = new URL(url, window.location.origin);

    // Check if it's a same-origin URL
    if (urlObj.origin !== window.location.origin) {
      // External URL, use full page refresh
      window.location.href = url;
      return;
    }

    const pathname = urlObj.pathname;
    const search = urlObj.search;
    const hash = urlObj.hash;
    const fullPath = pathname + search + hash;

    // Use History API to navigate without refresh
    // React Router's BrowserRouter listens to popstate events and location changes
    window.history.pushState({}, '', fullPath);

    // Manually trigger a popstate event to ensure React Router picks up the change
    // This is necessary because pushState doesn't automatically fire popstate
    const popStateEvent = new PopStateEvent('popstate', { state: {} });
    window.dispatchEvent(popStateEvent);
  } catch (err) {
    // Fallback to full page refresh if URL parsing fails
    console.error('Failed to parse URL for client-side navigation', err);
    window.location.href = url;
  }
}

type PreventableEvent = {
  stopPropagation(): void;
  preventDefault(): void;
};

/** Accepts any event-like object with stopPropagation + preventDefault. */
export function handleDomBubbleEvent<T extends PreventableEvent>(e: T) {
  e.stopPropagation();
  e.preventDefault();
}
